import React from 'react';
import { HTML_ENTITY_REGEX } from '../../utilities/constants';

export interface HtmlEntityText {
    text: string;
}
/**
 * Display text as innerHTML if an HTML entity (i.e. "&nbsp;") is included.
 */
const HtmlEntityTextComponent = ({ text }: HtmlEntityText & React.HTMLAttributes<Element> ): React.ReactElement | null => {

    if (text && HTML_ENTITY_REGEX.test(text)) {
        // React intentionally named this for the programmer to be mindful of what they're doing. We are
        // setting the HTML from a string generated in the CMS https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
        return <span dangerouslySetInnerHTML={ { __html: text } }></span>;
    }

    return <>{ text }</>;
};

export default HtmlEntityTextComponent;
